import { Router } from 'vue-router';
import LoadingService from '@/dossier/services/LoadingService';
import { delay } from '@/shared/utils';

export default async function setupTransitionGuard(router: Router): Promise<void> {
  let active = false;

  router.beforeEach(async (to, from, next) => {
    // beforeEach can get called multiple times in a single transition (e.g. due to redirects)
    // ignore transitions to the same route (e.g. with changed params)
    // in these cases, changes to the view are usually minimal and showing a loading indicator
    // is not always needed or desirable
    // it also avoids (briefly) showing a loading indicator when opening a router based modal
    if (!active && to.name !== from.name) {
      active = true;
      LoadingService.start();
      // we need a small timeout before proceeding to allow the loading state to be rendered
      // otherwise the loading state may only become visible until after the route transition
      await delay(10);
    }
    next();
  });

  const handleStop = (): void => {
    if (active) {
      active = false;
      LoadingService.stop();
    }
  };

  router.afterEach(handleStop);
  router.onError(handleStop);
}
